var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, MenuItem, TextField } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useEntityContext } from '..';
const StyledDialog = styled(Dialog) `
  .select-rule {
    margin-top: 12px;
  }
  .rule {
    margin-top: 12px;
  }
  .about {
    margin: 12px 0;
  }
`;
export const EditEntityRuleDialog = (_a) => {
    var _b;
    var { entity, rule: initialRule, onCancel, onChange } = _a, props = __rest(_a, ["entity", "rule", "onCancel", "onChange"]);
    const { rules, trackChanges } = useEntityContext();
    const [rule, setRule] = useState(initialRule);
    const plugin = rule && rules.find(plugin => plugin.type === rule.type);
    return (React.createElement(StyledDialog, Object.assign({ fullWidth: true }, props),
        React.createElement(DialogTitle, null, "Entity Rule"),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, { gutterBottom: true }, "An entity rule applies custom business logic to the entity. Rules can define required entity columns and relationships."),
            React.createElement(TextField, { select: true, fullWidth: true, className: 'select-rule', variant: 'outlined', size: 'small', label: 'Entity Rule', value: (rule === null || rule === void 0 ? void 0 : rule.type) || '', onChange: event => {
                    const type = event.target.value;
                    setRule({ type });
                } },
                React.createElement(MenuItem, { selected: true, disabled: true }, "Select Rule Type"),
                rules.map(plugin => (React.createElement(MenuItem, { key: plugin.type, value: plugin.type }, plugin.name)))),
            (() => {
                if (!rule || !rule.type)
                    return null;
                if (!plugin) {
                    return (React.createElement(Alert, { severity: 'error' },
                        "Rule \"",
                        rule.type,
                        "\" plugin not found."));
                }
                return (React.createElement("div", { className: 'rule' },
                    plugin.description && (React.createElement(Alert, { severity: 'info', className: 'about' }, plugin.description)),
                    plugin.configurator && (React.createElement(plugin.configurator, { rule: rule, onChange: rule => {
                            setRule(Object.assign({}, rule));
                        } }))));
            })()),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', onClick: () => onCancel === null || onCancel === void 0 ? void 0 : onCancel() }, "Cancel"),
            React.createElement(Button, { variant: 'contained', color: 'primary', disabled: Boolean(!rule) || (rule && (plugin === null || plugin === void 0 ? void 0 : plugin.validate))
                    ? !((_b = plugin === null || plugin === void 0 ? void 0 : plugin.validate) === null || _b === void 0 ? void 0 : _b.call(plugin, rule))
                    : false, onClick: () => {
                    if (!rule)
                        return;
                    if (plugin === null || plugin === void 0 ? void 0 : plugin.columns) {
                        for (const column of plugin.columns) {
                            if (!entity.columns.some(c => c.name === column.name)) {
                                trackChanges.insert('columns', column);
                            }
                        }
                    }
                    if (plugin === null || plugin === void 0 ? void 0 : plugin.relations) {
                        for (const relation of plugin.relations) {
                            if (!entity.relations ||
                                !entity.relations.some(r => r.propertyName === relation.propertyName)) {
                                if (!entity.relations) {
                                    trackChanges.update('relations', []);
                                }
                                trackChanges.insert('relations', relation);
                            }
                        }
                    }
                    onChange === null || onChange === void 0 ? void 0 : onChange(rule);
                } }, "Save"))));
};
export default EditEntityRuleDialog;
//# sourceMappingURL=EditEntityRuleDialog.js.map